import { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Col, Row } from "antd";
import styled from "styled-components";
import Title from "../../../components/Title";
import { BranchesOutlined } from "@ant-design/icons";
import { TYPE_GET_DATE } from "../../../../helper/const";
import {
  getDateChangeTime,
  formatDataBitelAirtimeDetail,
  formatDataTimer,
  formatDataBitelAirtimeByDate,
} from "../../../../helper/helper";
import FilterTime from "../../../components/FilterTime";
import _, { clone, cloneDeep } from "lodash";
import DashboardAirtime from "../../../Natcom/components/DashboardAirtime";
import Tables from "../../../components/Tables";

export default function Overview({ handleGetData, tabActive }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );

  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));

  const { result = {} } = useSelector((state) => state.reducerAirtimeBitel?.data) || {};

  const { data: airtime_bitel, data_table: airtime_bitel_table } = result;
  useEffect(() => {
    if (tabActive !== "1") return;
    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  const sortData = (data) => {
    if (_.isEmpty(data)) return [];
    const sortData = data.sort((x, y) => {
      if (x.date === "" && y.date !== "") return -1;
    });

    let dataDashboar = sortData.sort((x, y) => {
      const dateX = new Date(x.time);
      const dateY = new Date(y.time);
      return dateX - dateY;
    });
    
   const dataReturn = _.flatMap(dataDashboar, item => [
    {time: item.time, totalData: item.totalAdvance, name: "totalAdvance"},
    {time: item.time, totalData: item.totalAdvanceFee, name: "totalAdvanceFee"},
    {time: item.time, totalData: item.totalRecoveryOriginFee, name: "totalRecoveryOriginFee"}
   ])
    return dataReturn
  };

  const columns = useMemo(() => {
    if (_.isEmpty(airtime_bitel) || tabActive !== "1") {
      return [];
    }
    let dataColumn = [];
    for (let x in airtime_bitel) {
      const formatData = formatDataBitelAirtimeDetail(
        airtime_bitel[x],
        x,
        "overview"
      );
      
      formatData.forEach((item) => {
        dataColumn = [item, ...dataColumn];
      });
    }
    dataColumn = dataColumn.filter((item = {}) => {
      if (item.airtime === "TOTAL") {
        return item;
      }
    });
    dataColumn = dataColumn.map((item = {}) => {
      const data = {
        time: item.idData,
        totalAdvance: item.total_advance_fee - item.total_fee || 0,
        totalAdvanceFee: item.total_advance_fee || 0,
        totalRecoveryOriginFee: item.total_recovery_origin_fee || 0,
      };
      return data;
    });
    
    return sortData(dataColumn) || [];
  }, [airtime_bitel, startDate, endDate]);
  
  const dataDetail = {
    data: formatDataTimer(columns || []),
    xField: "time",
    yField: "totalData",
    seriesField: "name"
  };
  
  const width = columns.length * 25


  let dataTableAirtime = [];
  for(const date in airtime_bitel_table){
    const totalItem = _.last(airtime_bitel_table[date]) || {};
    if(totalItem){
      dataTableAirtime.push(totalItem);
    }
  }
  dataTableAirtime = dataTableAirtime.sort((a, b) => new Date(b.date) - new Date(a.date)); 

  const columnTable = useMemo(() => {
    if (dataTableAirtime) {
      const data = formatDataBitelAirtimeByDate(dataTableAirtime);   
      return data;
    }
  }, [dataTableAirtime]);
  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
      </div>
      <Container className="panel panel-sortable" width={width}>
        <Title titleName="Overview">
          <BranchesOutlined />
        </Title>
        <Col span={24}>
          <Col xs={24} lg={24} className="container-item">
            <h4 className="pt-3 pe-3 pb-5">Overview total chart:</h4>
            <div className="item-chart">
              <DashboardAirtime
                dataDashboard={dataDetail}
                isHiddenContainer
                width={1100}
              />
            </div>
          </Col>
        </Col>
      </Container>
      <Tables
        className="py-2"
        columns={columnTable}
        title="Overview statistic table"
        isHiddenPagination={false}
      />
    </>
  );
}

const Container = styled(Row)`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 20px;

  .item-chart{
    min-width: ${props => `${props.width}px`};
    overflow-x: auto;
  }
`;



